import { useFormat } from "../../../../../i18n/format";

/**
 * Amounts in the payment lists, in the reader's language: "$1,234.56" in English (the
 * same text helpers/money writes) and "1 234,56 $" in French. Blank or unreadable
 * amounts read "—", and -0.001 reads $0.00, not -$0.00. For display only.
 */
export const useMoney = () => {
  const { formatMoney } = useFormat();
  return (value) => {
    if (typeof value !== "number" && typeof value !== "string") return "—";
    if (typeof value === "string" && value.trim() === "") return "—";
    const amount = Number(value);
    if (!Number.isFinite(amount)) return "—";
    return formatMoney(Math.abs(amount) < 0.005 ? 0 : amount);
  };
};
